<script setup>
/* global axios */
import { ref, watch } from 'vue';
import { useAccount } from 'dashboard/composables/useAccount';
const props = defineProps({ canManage: { type: Boolean, default: false } });
const { accountId } = useAccount();
const content = ref('');
const error = ref('');
const state = ref('');
let revision = 0;
watch([accountId, () => props.canManage], async () => {
  const current = ++revision;
  content.value = ''; error.value = ''; state.value = '';
  if (!props.canManage) return;
  state.value = 'Загрузка…';
  try {
    const { data } = await axios.get(`/api/v1/accounts/${accountId.value}/lilith/account_configuration`);
    if (current !== revision) return;
    content.value = JSON.stringify(data.sections, null, 2); state.value = '';
  } catch (_) {
    if (current === revision) { error.value = 'Настройки недоступны. Проверьте права или повторите позже.'; state.value = ''; }
  }
}, { immediate: true });
async function save() {
  if (!props.canManage || state.value) return;
  const current = revision;
  const target = accountId.value;
  error.value = ''; state.value = 'Сохранение…';
  try {
    const sections = JSON.parse(content.value);
    const { data } = await axios.patch(`/api/v1/accounts/${target}/lilith/account_configuration`, { sections });
    if (current !== revision) return;
    content.value = JSON.stringify(data.sections, null, 2); state.value = 'Сохранено';
  } catch (_) {
    if (current === revision) { error.value = 'Не удалось сохранить. Проверьте JSON и права; успешное сохранение не подтверждено.'; state.value = ''; }
  }
}
</script>
<template>
  <details v-if="canManage" class="rounded-xl border border-n-weak bg-n-surface-2 p-5">
    <summary class="cursor-pointer font-semibold">Настройки компании Lilith</summary>
    <p class="my-3 text-sm">Общие настройки компании применяются только в текущем account. Настройки выбранного ассистента остаются в разделах выше. Квоты и провайдеров изменяет SuperAdmin.</p>
    <textarea v-model="content" aria-label="Настройки компании Lilith JSON" class="w-full rounded border border-n-weak bg-n-surface-1 p-3 font-mono text-xs" rows="18" :disabled="!!state && state !== 'Сохранено'" />
    <p role="status">{{ state }}</p><p v-if="error" role="alert">{{ error }}</p>
    <button type="button" class="mt-3 rounded border border-n-weak px-4 py-2" :disabled="!content || (!!state && state !== 'Сохранено')" @click="state = ''; save()">Сохранить настройки компании</button>
  </details>
</template>
